<template>
    <div class="addTicket">
        <!-- 添加券号信息 -->
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item label="类型名称" prop="typeCode">
                            <el-select v-model="value8" filterable placeholder="试一试搜索:类型名称" :loading="loading" :disabled="true">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            
                            </el-select>
                        </el-form-item>
                        <el-form-item label="已生成数量" prop="totalGeneratedQty">
                            <el-input v-model="ruleForm.totalGeneratedQty" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="生成数量" prop="qty">
                            <el-input v-model="ruleForm.qty" placeholder="请填写生成数量"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" 
                                @click="submitForm('ruleForm')"
                            >确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin],
    data(){
        var validatorQty = (rule,value,callback) => {
            if(value != ''){
                if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false){
                    callback(new Error("请填写大于0的数字"));
                }else if(isNaN(value)||value<=0||!(/^\d+$/.test(value))){
                    callback(new Error("请输入大于0的整数"));
                }
                else{
                    callback();
                }
            }else{
                callback(new Error("请填写大于0的数字"));
            }
        }
        return {
            ruleForm:{
                typeCode : '',
                totalGeneratedQty : '',
                qty : '',
            },
            rules:{
                typeCode:[
                    { required: true, message: '请刷新重试', trigger:'blur'}
                ],
                qty:[
                    { validator : validatorQty,required : true,trigger:'blur',type:'number'},
                    { min: 1, max: 5, message: '长度在 1 到 5 个数字', trigger: 'blur' }
                ]
            },
            options:[
                { 
                    value : '001',
                    label : '显示'
                }
            ],
            value8:'',
            selectData : [],
            
        }
    },
    created (){
       
    },
    mounted(){
        /**
         * 
        */
        let description = this.$route.query.description;
        // console.log(description)
        let typeCode = this.$route.query.typeCode;
        let totalGeneratedQty = this.$route.query.totalGeneratedQty;
        this.options[0].label = description;
        this.value8 = description;
        this.ruleForm.typeCode = typeCode;
        this.ruleForm.totalGeneratedQty = totalGeneratedQty;
    },
    methods:{
        //保存券号信息
        submitForm(formName) {   
            this.$refs[formName].validate((valid) => {
                if (valid) { 
                    let loading = this.loadingCommon();
                    let userId = sessionStorage.getItem("userId") ;
                    let { typeCode,qty } = this.ruleForm;
                    let params = {
                        act:'createCoupon',
                        typeCode,
                        qty,
                        userId
                    }
                    this.$confirm( `确定生成 ${qty} ?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center :true
                    }).then(() => {
                        this.findType(params).then( (res) => {
                            if(res.data.status == true){
                                loading.close();
                                this.promptMsg('添加成功','success') 
                                this.ruleForm.qty = '' ;
                                this.selectTypes();
                            }else{
                                loading.close();
                                if(res.data.msg){
                                    this.alert(res.data.msg,"warning")
                                }else{
                                    this.alert('添加失败',"warning")
                                }   
                            }
                        })
                    }).catch(() => {
                        loading.close();
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        }); 
                    });
                    //console.log(params)
                   
                   // this.$router.push({path:'/'}) //跳转页面  
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        //搜索类型编号
        selectTypes(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findTypes',
                userId
            }
            this.findType(params).then( (res) =>{
                if(res.data.status == true){
                    let resultData = res.data.list;
                    let { typeCode } = this.ruleForm ;
                    let qtyObj = resultData.find((elem) => elem.typeCode == typeCode) ;
                    if( qtyObj ){
                        this.ruleForm.totalGeneratedQty = qtyObj.totalGeneratedQty
                    }
                }else{}
            })
        },
    }
}
</script>
